window.showToast = function(message, type = "success", autoClose = true) {
  const toast = document.createElement('div');
  toast.className = `custom-cart-message ${type}`;
  toast.textContent = message;
  document.body.appendChild(toast);

  toast.style.display = 'block';

  if (autoClose) {
    setTimeout(() => {
      toast.remove();
    }, 2000);
  }

  return toast; // Return so we can manually close it
};
